import styled from 'styled-components'
import ReactSelect from 'react-select'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  disabled?: boolean
}

export const Select = styled(ReactSelect)`
  margin-left: 0.5px;
  .Select__control {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
    height: 26px;
    width: 99px;
    padding-left: 10px;
    background: #0087c129;

    border: none;

    box-sizing: border-box;
    &:hover {
      outline: hidden;
      background-color: #0087c129;
    }
  }
  .Select__control--is-focused {
    border: none;
    box-shadow: none;
    outline: hidden;
    &:hover {
      outline: hidden;
    }
  }
  .Select__indicator-separator {
    display: none;
  }
  .Select__indicator {
    color: #0087c1;
    padding-right: 15px;
    &:hover {
      color: #0087c1;
    }
  }
  .Select__menu {
    position: relative;
    background-color: #0087c129;
    color: #0087c1;
    width: 99px;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
    box-sizing: border-box;
    margin-top: 2px;
    border-radius: 4px;
    border: none;
  }
  .Select__option {
    padding-left: 20px;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    padding: 15px 30px;
    text-align: left;
    overflow: hidden;
    height: 28px;
    width: 99px;
    &:hover {
      background-color: #0087c129;
      color: #0087c1;
    }
  }
`

export const SelectContainer = styled.div`
  position: relative;
  height: 58px;
`

export const InputError = styled.div`
  font-family: 'Roboto';
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: start;
  box-sizing: border-box;
  padding: 5px 20px;
  width: 99px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #f60665;
`
